<div class="rl-notification-wrapper" *ngIf="isVisible">
  <div class="rl-notification-box">
    <div class="rl-icon-area">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <div class="rl-text-area">
      <div class="rl-header-text">Límite de solicitudes alcanzado</div>
      <div class="rl-body-text">{{ getMessage() }}</div>
      <div class="rl-progress-container">
        <div class="rl-progress-bar" [style.width.%]="progressPercentage"></div>
      </div>
    </div>
  </div>
</div>
